import { DynamicComponentLoaderModule } from '@adaptiva/core/loaders';
import { CheckboxGroupComponentModule } from '@adaptiva/widgets/checkbox-group';
import { ContainerComponentModule } from '@adaptiva/widgets/container';
import { LabelComponentModule } from '@adaptiva/widgets/label';
import { TextComponentModule } from '@adaptiva/widgets/text';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RecurringByDayComponent } from './recurring-by-day.component';

@NgModule({
	imports: [
		CheckboxGroupComponentModule,
		CommonModule,
		ContainerComponentModule,
		DynamicComponentLoaderModule.forChild(RecurringByDayComponent),
		LabelComponentModule,
		TextComponentModule,
	],
	declarations: [RecurringByDayComponent],
	exports: [RecurringByDayComponent]
})
export class RecurringByDayModule {

}
